import modulesMap from 'core/modulesMap';
import Component from 'navigation/component/Component';
class Tabs extends Component {
    activeTab = null;
    initialized() {
        super.initialized();
        // this.refs.tabsLinks[0].classList.add('active')
        this.activeTab = this.el.querySelector('.active');
        this.updateTrack(this.activeTab);
    }
    getModulesMap() {
        return {
            ...modulesMap
        };
    }
    bindEvents(add) {
        this.refs.tabsLinks.forEach(link => {
            link.addEventListener('click', () => this.handleTabClick(link));
        });
    }
    handleTabClick = (link) => {
        this.activeTab = link;
        this.refs.tabsLinks.forEach(link => link.classList.remove('active'));
        link.classList.add('active');
        this.emit('tabChange', link.dataset.tab);
        this.updateTrack(link);
    };
    updateTrack = (link) => {
        // resize track to fit the link
        this.refs.tabsTrack.style.width = `${link?.offsetWidth}px`;
        // move track to the position of the link
        this.refs.tabsTrack.style.left = `${link?.offsetLeft}px`;
    };
    resize() {
        if (this.activeTab) {
            this.emit('tabChange', this.activeTab.dataset.tab);
            this.updateTrack(this.activeTab);
        }
    }
}
export default Tabs;
